class Config
{

    constructor(defaults, options) {
        if (typeof defaults === 'undefined') {
            defaults = {}
        }
        if (typeof options === 'undefined') {
            options = {}
        }
        this._options = Object.assign({}, defaults, options);
    }

    all()
    {
        return this._options;
    }

    get(key, defaultValue)
    {
        if (key in this._options) {
            return this._options[key];
        }
        return defaultValue;
    }

}

export default Config;
